import axios from '@/axios'

const activity = {
  async getActivityDetail(params = {}) {
    return await axios.post('/uc/firstChargeActivity/queryFirstChargeActivityDetail', params, { des: '直客wap获取活动详情信息', sTime: new Date().getTime() })
  },
  async applyGold(params) {
    return await axios.post('/uc/firstChargeActivity/applyGold', params, { des: '直客wap申领交易赠金', sTime: new Date().getTime() })
  },
  //获取活动列表
  async getActiveList(params) {
    return await axios.post('/uc/NonFarmActivity/getActivityList', params, { des: '直客wap获取活动列表', sTime: new Date().getTime() })
  },
  //申请奖励 
  async getReward(params) {
    return await axios.post('/uc/NonFarmActivity/reward', params, { des: '直客wap申请奖励', sTime: new Date().getTime() })
  },
  //非农活动-查看个人信息 
  async getNonFarmActivityDetail(params) {
    return await axios.post('/uc/NonFarmActivity/queryUserActivityFnDetail', params, { des: '直客wap非农活动-查看个人信息', sTime: new Date().getTime() })
  },
  // 新旧版首充活动状态
  async getFirstChargeActivityIsCanSc(params) {
    return await axios.post('/uc/firstChargeActivity/isCanSc', params)
  },
  // 新旧版首充活动状态
  async queryNewFirstChargeActivity(params) {
    return await axios.post('/uc/firstChargeActivity/queryNewFirstChargeActivity', params)
  },
  // 充值送活动状态
  async chargeSendDetail(params) {
    return await axios.post('/uc/firstChargeActivity/chargeSendDetail', params)
  },
}

export default activity


// WEBPACK FOOTER //
// ./src/api/activity.js